// import $ from 'jquery';
// import Swiper from 'swiper';
// import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default (function () {
  var jackpotsSlider = new Swiper('.jackpots', {
    // modules: [Autoplay],
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1
    },
    loop: true,
    slidesPerView: 'auto'
  });
  var eventsSlider = new Swiper('.events-slider', {
    // modules: [Navigation],
    spaceBetween: 14,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
      nextEl: '.events-swiper-button-next',
      prevEl: '.events-swiper-button-prev'
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      }
    }
  });
  var newsSlider = new Swiper('.news-slider', {
    // modules: [Navigation],
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
      nextEl: '.news-swiper-button-next',
      prevEl: '.news-swiper-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
        centeredSlides: false,
        loop: false
      },
      640: {
        slidesPerView: 2,
        centeredSlides: false,
        loop: false
      }
    }
  });
  var boxGallerySlider = new Swiper('.box-gallery__slider', {
    // modules: [Pagination],
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    pagination: {
      el: '.box-gallery__swiper-pagination',
      clickable: true
    },
    on: {
      beforeInit: function beforeInit() {
        var slides = this.el.querySelectorAll('.swiper-slide');
        if (slides) {
          this.params.loop = slides.length > 1;
          this.params.autoplay.enabled = slides.length > 1;
        }
      }
    }
  });
  var heroSlider = new Swiper('.hero', {
    // modules: [Pagination, Autoplay],
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    pagination: {
      el: '.hero__swiper-pagination',
      clickable: true
    },
    on: {
      beforeInit: function beforeInit() {
        var slides = this.el.querySelectorAll('.swiper-slide');
        if (slides) {
          this.params.loop = slides.length > 1;
          this.params.autoplay.enabled = slides.length > 1;
        }
      }
    }
  });
  var heroSliderXL = new Swiper('.hero-xl', {
    // modules: [Pagination, Autoplay],
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: '.hero__swiper-pagination',
      clickable: true
    },
    on: {
      beforeInit: function beforeInit() {
        var slides = this.el.querySelectorAll('.swiper-slide');
        if (slides) {
          this.params.loop = slides.length > 1;
          this.params.autoplay.enabled = slides.length > 1;
        }
      }
    }
  });
  var sliderImgText = new Swiper('.slider-img-text__slider', {
    // modules: [Pagination, Autoplay],
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    effect: 'fade',
    autoHeight: true,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: '.slider-img-text__pagination',
      clickable: true
    },
    breakpoints: {
      1023: {
        autoHeight: false
      }
    },
    on: {
      beforeInit: function beforeInit() {
        var slides = this.el.querySelectorAll('.swiper-slide');
        if (slides) {
          this.params.loop = slides.length > 1;
          this.params.autoplay.enabled = slides.length > 1;
        }
      }
    }
  });
  var imgSlider = function imgSlider() {
    var sliders = document.querySelectorAll('.slider-img .swiper');
    //let pagination = document.querySelectorAll('.slider-img__swiper-pagination');
    sliders.forEach(function (slider, index) {
      var pagination = slider.querySelector('.slider-img__swiper-pagination');
      var sliderLength = slider.children[0].children.length;
      var result = sliderLength > 1 ? true : false;
      var swiper = new Swiper(slider, {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        watchOverflow: true,
        pagination: pagination ? {
          el: pagination,
          clickable: true,
          /*Return bullets as numbers*/
          renderBullet: function renderBullet(index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          }
        } : false
      });
    });
  };
  imgSlider();
});